import React from 'react';
import Features from './Features';
import Advantages from './Advantages';
import { FAQ } from '../FAQ/faqs';
import Footer from '../Footer';


function SalesAndDistribution() {
  return (
    <>
<Features docname="Sales and Distribution"/>
<Advantages docname="Sales and Distribution"/>
<FAQ category="About Accxchange"/>
<Footer segment="Smarty Home"/>
    </>
  );
}

export default SalesAndDistribution;
